import { render, staticRenderFns } from "./RegistrationBackgroundFormField.vue?vue&type=template&id=3d6b171a&scoped=true"
import script from "./RegistrationBackgroundFormField.vue?vue&type=script&lang=js"
export * from "./RegistrationBackgroundFormField.vue?vue&type=script&lang=js"
import style0 from "./RegistrationBackgroundFormField.vue?vue&type=style&index=0&id=3d6b171a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6b171a",
  null
  
)

export default component.exports